import { useEffect } from 'react'

// Pressing "/" anywhere (outside a text field) focuses the given input — the
// familiar search shortcut. Selects existing text so you can retype immediately.
export function useSlashFocus(ref) {
  useEffect(() => {
    function onKey(e) {
      if (e.key !== '/' || e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return
      const t = e.target
      const tag = t?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || t?.isContentEditable) return
      const el = ref.current
      if (!el) return
      e.preventDefault()
      el.focus()
      if (typeof el.select === 'function') el.select()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [ref])
}
